import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Col,
  Row,
  Form,
  Space,
  Button,
  Upload,
  Input,
  message,
  Typography,
  Tooltip,
  Timeline,
} from "antd";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  DateField,
  InputField,
  InputRadio,
  ReactSelectField,
  TextAreaField,
} from "../../../atoms/FormElement";
import type { CheckboxProps } from "antd";
import { LoaderIcon } from "../../../atoms/Icons";
import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import TemplatePreview from "../../../atoms/TemplatePreview";
import axios from "axios";
import { portalService } from "../../../../configs/constants";
import { uploadDocumentMedia, uploadToS3 } from "../../../../utils/media";
import { sendBulkNotification } from "../ducks/actions";
import {
  Checkbox,
  Collapse,
  Dropdown,
  Menu,
  Radio,
  Switch,
  Table,
} from "antd/es";
import SectionHeader from "../../../molecules/SectionHeader";
import { useSelector } from "react-redux";
import { CaretRightOutlined } from "@ant-design/icons";
import { MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../../atoms/Popup";
import Title from "antd/es/typography/Title";

const ScheduledComm = React.memo((props: any) => {
  const { handleTabChange } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [DATA, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [currentRecord, setCurrentRecord] = useState(null);
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({ shouldUnregister: false });
  const [currentTemplate, setCurrentTemplate] = useState({
    html: "",
    variables: {},
  });

  // Handle menu item click
  const handleMenuClick = async (record, e) => {
    if (e.key === "edit") {
      console.log("Edit clicked for:", record);
      handleTabChange("2", setSearchParams);
    }
    if (e.key === "Preview") {
      setVisible(true);
      setCurrentRecord(record);
      console.log("record", record);
    }
    if (e.key === "delete") {
      setCurrentRecord(record);
      console.log("id", record._id);
      try {
        const response = await axios.delete(
          `${portalService}/communication/scheduler/${record._id}/cancel`
        );
        console.log("response", response?.status);
        if (response?.status === 200) {
          setData(DATA.filter((item) => item._id !== record._id));
        }
        // setData(parsedData || []);
      } catch (error) {
        message.error("Failed to load templates.");
      }
      // deleteRecord(record._id)
    }
  };

  const fetchData = async () => {
    const DATA1 = [
      {
        key: "1",
        name: "Task Scheduler",
        frequency: "Weekly",
        createdBy: "Alice Johnson",
        lastUpdatedDate: "2025-06-28",
        isActive: true,
        loading: false,
      },
      {
        key: "2",
        name: "Data Sync",
        frequency: "Daily",
        createdBy: "Bob Smith",
        lastUpdatedDate: "2025-06-27",
        isActive: false,
        loading: false,
      },
      {
        key: "3",
        name: "Report Generator",
        frequency: "Monthly",
        createdBy: "Carol Davis",
        lastUpdatedDate: "2025-06-25",
        isActive: true,
        loading: true, // This will show the LoaderIcon
      },
      {
        key: "4",
        name: "Notification Service",
        frequency: "Hourly",
        createdBy: "David Lee",
        lastUpdatedDate: "2025-06-30",
        isActive: false,
        loading: false,
      },
      {
        key: "5",
        name: "Backup Routine",
        frequency: "Weekly",
        createdBy: "Evelyn Martinez",
        lastUpdatedDate: "2025-06-29",
        isActive: true,
        loading: false,
      },
    ];

    // setData(DATA1 || []);
    // return
    try {
      const response = await axios.get(
        `${portalService}/communication/scheduler/list`
      );

      const parsedData = response?.data?.map((item, key) => {
        return {
          ...item,
          key: key,
          createdBy: item?.createdBy || "- -",
          name: item?.name || "- -",
          frequency: item?.scheduler?.cronExpression,
          status: item?.isActive,
          lastUpdatedDate:
            item?.updatedAt &&
            dayjs(item?.updatedAt).format("DD/MM/YYYY HH:mm"),
        };
      });

      setData(parsedData || []);
    } catch (error) {
      message.error("Failed to load templates.");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const changeStatus = async (record) => {
    let success: any = false;
    setData(
      DATA.map((item) => item._id === record._id && { ...item, loading: true })
    );
    try {
      const response = await axios.patch(
        `${portalService}/communication/scheduler/${record._id}/status`,
        {
          isActive: !record.isActive,
        }
      );
      if (response?.data) {
        message.success("Success");
        success = response?.data;
      } else {
        success = false;
      }
    } catch (error) {
      success = false;
      message.error("Failed to load templates.");
    }
    setData(
      DATA.map((item) =>
        item._id === record._id
          ? {
              ...item,
              isActive: !!success ? success.isActive : record.isActive,
              loading: false,
            }
          : { ...item }
      )
    );
  };

  const renderMenu = (record) => (
    <Menu onClick={(e) => handleMenuClick(record, e)}>
      <Menu.Item key="Preview">Preview</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );
  const callStatusChangeApi = (record) => {
    changeStatus(record);
  };
  const handleToggle = (key, checked) => {
    const newData = DATA.map((item) =>
      item.key === key ? { ...item, status: checked } : item
    );
    setData(newData);
    console.log("Toggled:", key, checked);
  };
  const assignTechCol = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width: 220,
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      // width: 220,
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      key: "createdBy",
    },

    {
      title: "Last Updated Date",
      dataIndex: "lastUpdatedDate",
      key: "lastUpdatedDate",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "10%",
      render: (_, record) => {
        console.log("record", record);
        if (record.loading) return <LoaderIcon />;
        else
          return (
            <>
              <Switch
                checked={record.isActive}
                onChange={(checked) => {
                  callStatusChangeApi(record);
                  // handleToggle(record.key, checked);
                }}
                checkedChildren=""
                unCheckedChildren=""
                size="small"
              />
            </>
          );
      },
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "4%",
      render: (_, record) => (
        <Dropdown overlay={renderMenu(record)} trigger={["click"]}>
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];
  const onFinish = () => {};
  console.log("currentRecord", currentRecord);
  // ant-modal-body
  // dangerouslySetInnerHTML={{ __html: htmlContent }}
  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          {currentRecord?.name}
        </Title>
      ),
      content: (
        <>
          {currentRecord?.data?.html && (
            <div
              style={{
                padding: "8px 0px",
                border: "1px solid #f0f0f0",
                borderRadius: "12px",
                backgroundColor: "#F1F1F7",
                minHeight: "300px",
                maxHeight: "420px",
                overflow: "auto",
              }}
              dangerouslySetInnerHTML={{ __html: currentRecord.data.html }}
            />
          )}
        </>
      ),
      width: 700,
    },
  ];
  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };
  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        {/* <Row gutter={24}>
          <Col span={14}>
            <Row gutter={24}>
              <Col span={12}>
                Upload CSV with driverId or company-code &nbsp;{" "}
                <Tooltip
                  title={"Accepts values: driverId(s), Company-codes, all"}
                  arrow={false}
                >
                  <InfoCircleOutlined />
                </Tooltip>
                <Space size={0} style={{ paddingTop: "13px" }}>
                  <Upload
                    showUploadList={false}
                    {...generalFileProps(csvFile, setCsvFile, "csv")}
                  >
                    <Space size={0}>
                      <Input
                        readOnly
                        value={csvFile?.[0]?.name}
                        placeholder="Choose a file to upload"
                        disabled={loader}
                      />
                      <Button className="ag-gray-button" disabled={loader}>
                        Browse
                      </Button>
                    </Space>
                  </Upload>
                  &nbsp;&nbsp;
                  {loader && <LoaderIcon />}
                  {csvFile?.length > 0 && !loader && (
                    <Button
                      type="link"
                      icon={<DeleteOutlined />}
                      onClick={(e) => {
                        e.preventDefault();
                        setCsvFile([]);
                      }}
                    />
                  )}
                </Space>
              </Col>
              <Col
                span={12}
                className="main-checkbox"
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <ReactSelectField
                  fieldname="template"
                  style={{ width: "250px" }}
                  label="Please select a message template"
                  control={control}
                  initValue={""}
                  selectOption={popnoti.map((e) => ({
                    label: e.label,
                    value: e.value,
                  }))}
                  onChange={handleTemplateChange}
                  isRequired={true}
                  rules={{ required: "Please select template" }}
                  validate={errors.template && "error"}
                  validMessage={errors.template && errors.template.message}
                />
              </Col>
              <Col span={14}>
                <InputField
                  label="Title"
                  fieldname="title"
                  iProps={{ placeholder: "Enter title" }}
                  maxLength={70}
                  initValue="Heavy rain expected in your area"
                  isRequired={true}
                  control={control}
                  rules={{ required: "Title Required" }}
                  validate={errors.title && "error"}
                  validMessage={errors.title && errors.title.message}
                />
              </Col>
              <Col
                span={10}
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <ReactSelectField
                  fieldname="status"
                  style={{ width: "250px" }}
                  label="Status"
                  control={control}
                  initValue={{
                    label: <div style={{ color: "#1890ff" }}>Info</div>,
                    value: "info",
                  }}
                  selectOption={[
                    {
                      label: <div style={{ color: "#1890ff" }}>Info</div>,
                      value: "info",
                    },
                    {
                      label: <div style={{ color: "#faad14" }}>Warning</div>,
                      value: "warn",
                    },
                    {
                      label: <div style={{ color: "#06b460" }}>Success</div>,
                      value: "success",
                    },
                    {
                      label: <div style={{ color: "#f5222d" }}>Failed</div>,
                      value: "failed",
                    },
                  ]}
                />
              </Col>
              <Col span={24}>
                <TextAreaField
                  label="Enter message"
                  fieldname="message"
                  iProps={{ placeholder: "Write your message" }}
                  initValue="To ensure your safety, and precautions and comfort of your passenger we recommend following precautions:"
                  control={control}
                  maxLength={150}
                  isRequired={true}
                  rules={{ required: "Message Required" }}
                  validate={errors.message && "error"}
                  validMessage={errors.message && errors.message.message}
                />
              </Col>
              <Col span={24}></Col>
              <Col span={6}>
                <DateField
                  label="Start Date"
                  fieldname="dateSearch"
                  control={control}
                  onChange={(e) => {
                    console.log("e", e);
                  }}
                  initValue={""}
                  iProps={{
                    placeholder: "DD-MM-YYYY",
                    format: "DD-MM-YYYY",
                    // disabledDate: disableCommenceDate,
                    // disabled: disableAll,
                  }}
                />
              </Col>
              <Col span={6}>
                <DateField
                  label="End Date"
                  fieldname="dateSearch"
                  control={control}
                  onChange={(e) => {
                    console.log("e", e);
                  }}
                  initValue={""}
                  iProps={{
                    placeholder: "DD-MM-YYYY",
                    format: "DD-MM-YYYY",
                    // disabledDate: disableCommenceDate,
                    // disabled: disableAll,
                  }}
                />
              </Col>
              <Col span={24}>Frequency </Col>
              <Col span={24}>
                <InputRadio
                  fieldname={"asd"}
                  label={"asd"}
                  control={control}
                  rules={{ required: "Message Required" }}
                  initValue=""
                  isRequired={true}
                  validate={errors.message && "error"}
                  options={[
                    { value: 1, label: "Now" },
                    { value: 2, label: "Daily" },
                    { value: 3, label: "Weekly" },
                    { value: 4, label: "Scheduled" },
                    { value: 5, label: "Custom" },
                  ].map((option) => (
                    <Radio key={option.value} value={option.value}>
                      {option.label}
                    </Radio>
                  ))}
                  validMessage={errors.message && errors.message.message}
                />
              </Col>
              <Col span={24}> Status</Col>
              <Col span={24}>
                <Radio value={""} key={"1"}>
                  {"Active"}
                </Radio>
                <Radio value={""} key={"1"}>
                  {"Inactive"}
                </Radio>
              </Col>
              {Object.entries(currentTemplate.variables).length > 0 && (
                <Col span={24}>
                  <Title level={5}>Template Variables</Title>
                </Col>
              )}
              {renderVariables}

              <Col
                span={24}
                style={{
                  marginTop: "5px",
                  marginBottom: "15px",
                  textAlign: "center",
                }}
              >
                <Button
                  className="ag-green-button theme_btn"
                  htmlType="submit"
                  disabled={!fileData?.csv || loader}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>

          <Col span={10}>
            <TemplatePreview
              {...currentTemplate}
              title={title}
              message={messageField}
              status={status?.value}
              setValue={setValue}
              editHtml={props?.editHtml}
              variables={Object.entries(currentTemplate.variables).reduce(
                (acc, [key], idx) => {
                  acc[key] = watchedVariables[idx];
                  return acc;
                },
                {}
              )}
            />
          </Col>
        </Row> */}

        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[20, 20]} justify="end">
                <Col span={24}>
                  <Table
                    columns={assignTechCol}
                    scroll={{ y: 500 }}
                    dataSource={DATA}
                    className="custom-table org_table_wrap custom-table-manage"
                    pagination={false}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <br />
        <br />
      </Form>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
});

export default ScheduledComm;
